export const dayStatuses = {
    CORPORATE_HOLIDAY: 'corporateHoliday',
    NON_STANDARD_WORKING_DAY: 'nonStandardWorkingDay',
    STANDARD_DAY: 'standardDay',
}

export const MONTH_NAME_KEYS = [
    "month.full.upper.jan",
    "month.full.upper.feb",
    "month.full.upper.mar",
    "month.full.upper.apr",
    "month.full.upper.may",
    "month.full.upper.jun",
    "month.full.upper.jul",
    "month.full.upper.aug",
    "month.full.upper.sep",
    "month.full.upper.oct",
    "month.full.upper.nov",
    "month.full.upper.dec",
]

export const ABBR_DAY_NAME_KEYS = [
    "week.abbr.sun",
    "week.abbr.mon",
    "week.abbr.tue",
    "week.abbr.wed",
    "week.abbr.thu",
    "week.abbr.fri",
    "week.abbr.sat",
]

export const SHORT_DAY_NAME_KEYS = [
    'week.short.capital.sun',
    'week.short.capital.mon',
    'week.short.capital.tue',
    'week.short.capital.wed',
    'week.short.capital.thu',
    'week.short.capital.fri',
    'week.short.capital.sat',
]

export const WORK_SCHEDULE_YEAR_START = 2003

export const corporateHolidayEditorModes = {
    CHANGE_NAME: 'changeName',
    DELETE: 'delete',
    MARK_AS_WORKING: 'markAsWorking',
}

export const sortBy = {
    DATE: 'date',
    NAME: 'name',
}
export const Exception = {
    RETRIEVE_HOLIDAYS_EXCEPTION: 'com.actimind.common.services.RetrieveHolidaysException',
    RETRIEVE_COUNTRIES_EXCEPTION: 'com.actimind.common.services.RetrieveCountriesException',
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/constants.js